<template>
  <div>
    <!-- Group By Switch -->
    <v-row
      class="no-print ma-0"
      align="center"
      justify="start"
    >
      <v-switch
        v-model="groupByGroup"
        :label="'Group by ' + groupLabel"
        dense
        hide-details
        class="mb-2"
      />
    </v-row>

     <!-- View Mode Toggle -->
     <v-row
       class="no-print ma-0"
       align="center"
       justify="end"
     >
        <v-btn-toggle
         v-model="viewMode"
         mandatory
         dense
         class="mb-2"
       >
        <v-btn
          small
          value="simple"
        >
          <v-icon
            small
            left
          >
            mdi-view-compact
          </v-icon>
          Simple
        </v-btn>
        <v-btn
          small
          value="detail"
        >
          <v-icon
            small
            left
          >
            mdi-view-list
          </v-icon>
          Detail
        </v-btn>
      </v-btn-toggle>
    </v-row>

    <!-- <view-x-selector /> -->
    <member-selector
      class="no-print"
      :members="members"
      :groups="groups"
      :selected-member.sync="selectedMember"
      :selected-group.sync="selectedGroups"
      :selected-job-level.sync="selectedJobLevel"
    />
    <v-data-table
      :group-by="groupByGroup ? 'group' : ''"
      sort-by="score"
      sort-desc
      :headers="headers"
 :items-per-page="adjustedSummery.filter(m=>(!selectedMember.length||selectedMember.includes(m.memberId))&&
        (!selectedGroups.length || selectedGroups.includes(m.group))&&
        (!selectedJobLevel.length || (m.jobLevel && selectedJobLevel.includes(m.jobLevel)))
      ).length"
      dense
      item-key="memberId"
      :expanded="expanded||adjustedSummery"
      :items="adjustedSummery.filter(m=>(!selectedMember.length||selectedMember.includes(m.memberId))&&
        (!selectedGroups.length || selectedGroups.includes(m.group))&&
        (!selectedJobLevel.length || (m.jobLevel && selectedJobLevel.includes(m.jobLevel)))
      )"
      :loading="loading"
    >
      <template v-slot:group.header="{items, isOpen, toggle}">
        <th v-if="groupByGroup" colspan="8">
          <v-icon
            @click="toggle"
          >
            {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
          </v-icon>
          <span style="font-size: large">{{  groupMap[items[0].group] || items[0].group || 'Others' }}  {{ (items.reduce((sum,cv)=>sum+(cv.score||0),0)/(items.length||1)).toFixed(2) }} % </span>
        </th>
      </template>
      <template v-slot:item.sn="{ index }">
        <span>{{ index + 1 }}</span>
      </template>
      <template v-slot:item.regularHrs="{ item }">
        <span>{{ item.regularHrs | number('0.00') }}</span>
      </template>
      <template v-slot:item.missedPunch="{ item }">
        <span v-if="item.modifiedMissedPunch">{{ item.missedPunch | number('0.00') }} <span class="simple-modified"><v-icon x-small class="status-icon">mdi-pencil</v-icon>{{ item.modifiedMissedPunch | number('0.00') }}</span> hrs</span>
        <span v-else>{{ item.missedPunch| number('0.00') }} hrs</span>
      </template>
      <template v-slot:item.lateHrs="{ item }">
        <span>{{ item.lateHrs | number('0.00') }} hrs</span>
      </template>
      <template v-slot:item.penaltyHours="{ item }">
        <span>{{ item.penaltyHours | number('0.00') }} hrs</span>
      </template>
      <template v-slot:item.missedHrs="{ item }">
        <span v-if="item.modifiedMissedHrs">{{ item.missedHrs | number('0.00') }} <span class="simple-modified"><v-icon x-small class="status-icon">mdi-pencil</v-icon>{{ item.modifiedMissedHrs | number('0.00') }}</span> hrs</span>
        <span v-else>{{ item.missedHrs | number('0.00') }} hrs</span>
      </template>
      <template v-slot:item.missedHrsInOut="{ item }">
        <span>{{ item.missedHrsInOut | number('0.00') }}</span>
      </template>

      <template v-slot:item.absentDays="{ item }">
        <span>{{ (item.absentRecords || []).length | number('0') }}</span>
      </template>
      <template v-slot:item.apprMods="{ item }">
        <span>{{ getApprovedModCount(item) | number('0') }}</span>
      </template>
      <template v-slot:item.leaveDays="{ item }">
        <span>{{ item.leaveRecords.filter(l=>l.status==='Approved').length | number('0') }} <span v-if="item.leaveRecords.filter(l=>l.status!=='Approved').length" class="simple-modified"><v-icon x-small class="status-icon">mdi-pencil</v-icon>{{ item.leaveRecords.filter(l=>l.status!=='Approved').length }}</span> <span style="font-size: small">(A:{{ item.annualLeaveDays }} / U:{{ item.unpaidLeaveDays }} / O:{{ item.otherLeaveDays }})</span></span>
      </template>
      <template v-slot:item.fullPayHours="{ item }">
        {{ item.fullPayHours/item.fullExpectedHrs| percent(2) }} (<span style="font-size: small">{{ item.fullPayHours| number('0.00') }}/{{ item.fullExpectedHrs| number('0.00') }})</span>
      </template>
      <template v-slot:item.adjustedFullPayHours="{ item }">
        {{ item.adjustedFullPayHours/item.fullExpectedHrs| percent(2) }} (<span style="font-size: small">{{ item.adjustedFullPayHours| number('0.00') }}/{{ item.fullExpectedHrs| number('0.00') }})</span>
      </template>
      <template v-slot:item.dailyAvg="{ item }">
        <span>{{ item.dailyAvg| number('0.00') }}</span>
      </template>
      <!--      <template v-slot:item.totalOt="{ item }">-->
      <!--        <span>{{ item.totalOt | number('0.00') }} / {{ item.totalOtAll | number('0.00') }}</span>-->
      <!--      </template>-->

      <template v-slot:item.action="{ item }">
        <v-icon
          medium
          @click="$router.push({params:{id:item.memberId}})"
        >
          mdi-text-box
        </v-icon>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <!-- Simple View: Compact display for printing -->
        <template v-if="viewMode === 'simple'">
          <td :colspan="2" />

           <!-- Absent Days - Simple: machine-recorded absences -->
           <td>
             <span
               v-if="item.absentRecords && item.absentRecords.length"
               class="simple-dates body-2 text--primary"
             >
               <span v-for="(a, idx) in item.absentRecords" :key="'absent-simple-'+idx">
                 <span v-if="idx">, </span>{{ a.date | moment('DD') }}
                 <v-icon x-small class="absent-icon" style="vertical-align: middle">mdi-close-circle</v-icon>
               </span>
             </span>
             <span v-else>-</span>
           </td>

           <!-- Appr Mods - Simple: approved modifications with status icons -->
           <td>
             <span
               v-if="item.noRecordAbsentRecords && item.noRecordAbsentRecords.length"
               class="simple-dates body-2 text--primary"
             >
               <span v-for="(a, idx) in item.noRecordAbsentRecords" :key="'noRecord-simple-'+idx">
                 <span v-if="idx">, </span>{{ a.date | moment('DD') }}
                 <v-icon v-if="a.state === 'leave'" x-small class="leave-icon" style="vertical-align: middle">mdi-beach</v-icon>
                 <v-icon v-if="a.status === 'Approved'" x-small class="approved-icon" style="vertical-align: middle">mdi-check-circle</v-icon>
                 <v-icon v-if="a.status === 'Ready' && a.submittedBy" x-small class="status-icon" style="vertical-align: middle">mdi-arrow-up</v-icon>
                 <v-icon v-if="a.status === 'Pending' && a.modifiedBy" x-small class="modified-icon" style="vertical-align: middle">mdi-pencil</v-icon>
               </span>
             </span>
             <span v-else>-</span>
           </td>

          <!-- Leave Days - Simple: just comma-separated dates -->
          <td>
            <span
              v-if="item.leaveRecords && item.leaveRecords.length"
              class="simple-dates body-2 text--primary"
            >
              <span v-for="(a, idx) in item.leaveRecords" :key="'leave-simple-'+idx">
                <span v-if="idx">, </span>{{ a.date | moment('DD') }}
                <v-icon v-if="a.status === 'Approved'" x-small class="approved-icon" style="vertical-align: middle">mdi-check-circle</v-icon>
                <v-icon v-if="a.status === 'Ready' && a.submittedBy" x-small class="status-icon" style="vertical-align: middle">mdi-arrow-up</v-icon>
                <v-icon v-if="a.status === 'Pending' && a.modifiedBy" x-small class="modified-icon" style="vertical-align: middle">mdi-pencil</v-icon>
              </span>
            </span>
            <span v-else>-</span>
          </td>

          <!-- Missed Punch - Simple: comma-separated dates with In/Out indicator and icons for status -->
          <td>
            <span v-if="item.missedPunchRecords && item.missedPunchRecords.length" class="simple-dates body-2 text--primary">
              <span v-for="(a, idx) in item.missedPunchRecords" :key="'missed-simple-'+idx">
                <span v-if="idx">, </span>{{ formatDateWithPunchType(a) }}
                <v-icon v-if="a.status === 'Approved'" x-small class="approved-icon" style="vertical-align: middle">mdi-check-circle</v-icon>
                <v-icon v-if="a.status === 'Ready' && a.submittedBy" x-small class="status-icon" style="vertical-align: middle">mdi-arrow-up</v-icon>
                <v-icon v-if="a.status === 'Pending' && a.modifiedBy" x-small class="modified-icon" style="vertical-align: middle">mdi-pencil</v-icon>
              </span>
            </span>
            <span v-else>-</span>
          </td>

          <!-- Late Hours - Simple: compact format with status icons -->
          <td>
            <span
              v-if="item.lateHrsRecords && item.lateHrsRecords.length"
              class="simple-late-hours body-2 text--primary"
            >
              <span v-for="(a, idx) in item.lateHrsRecords" :key="'late-simple-'+idx">
                <span v-if="idx">, </span>{{ a.date | moment('DD') }}{{ formatSingleLateHours(a) }}
                <v-icon v-if="a.status === 'Approved'" x-small class="approved-icon" style="vertical-align: middle">mdi-check-circle</v-icon>
                <v-icon v-if="a.status === 'Ready' && a.submittedBy" x-small class="status-icon" style="vertical-align: middle">mdi-arrow-up</v-icon>
                <v-icon v-if="a.status === 'Pending' && a.modifiedBy" x-small class="modified-icon" style="vertical-align: middle">mdi-pencil</v-icon>
              </span>
            </span>
            <span v-else>-</span>
          </td>

          <!-- Penalty Hours - Simple: compact format with status icons -->
          <td>
            <span
              v-if="item.penaltyHoursRecords && item.penaltyHoursRecords.length"
              class="simple-late-hours body-2 text--primary"
            >
              <span v-for="(a, idx) in item.penaltyHoursRecords" :key="'penalty-simple-'+idx">
                <span v-if="idx">, </span>{{ a.date | moment('DD') }}{{ formatSinglePenaltyHours(a) }}
                <v-icon v-if="a.status === 'Approved'" x-small class="approved-icon" style="vertical-align: middle">mdi-check-circle</v-icon>
                <v-icon v-if="a.status === 'Ready' && a.submittedBy" x-small class="status-icon" style="vertical-align: middle">mdi-arrow-up</v-icon>
                <v-icon v-if="a.status === 'Pending' && a.modifiedBy" x-small class="modified-icon" style="vertical-align: middle">mdi-pencil</v-icon>
              </span>
            </span>
            <span v-else>-</span>
          </td>

          <td />
        </template>

        <!-- Detail View: Full detailed display -->
        <template v-else>
          <td :colspan="2" />

          <!-- Absent Days Detail -->
          <td>
            <div
              v-for="(a, idx) of item.absentRecords"
              :key="'absent-'+idx"
              class="detail-row"
            >
              <div class="detail-date">
                <v-icon
                  x-small
                  class="mr-1 absent-icon"
                >
                  mdi-close-circle
                </v-icon>
                <strong>{{ a.date | moment('ddd, D-MMM') }}</strong>
              </div>
              <div
                v-if="a.schedule && a.schedule.shift"
                class="detail-info"
              >
                <v-chip
                  x-small
                  outlined
                  class="shift-chip"
                >
                  {{ a.schedule.shift.name || 'Shift' }}
                </v-chip>
              </div>
              <div class="detail-info">
                <v-icon x-small class="absent-icon mr-1">mdi-close-circle</v-icon> Absent
              </div>
            </div>
          </td>

          <!-- Appr Mods Detail -->
          <td>
            <div
              v-for="(a, idx) of item.noRecordAbsentRecords"
              :key="'noRecord-'+idx"
              class="detail-row"
            >
              <div class="detail-date">
                <v-icon
                  x-small
                  class="mr-1"
                  :class="a.state === 'leave' ? 'leave-icon' : 'time-icon'"
                >
                  {{ a.state === 'leave' ? 'mdi-beach' : 'mdi-clock-edit-outline' }}
                </v-icon>
                <strong>{{ a.date | moment('ddd, D-MMM') }}</strong>
              </div>
              <div v-if="a.shift" class="detail-info">
                <v-chip x-small outlined class="shift-chip">
                  {{ a.shift.name || 'Shift' }}
                </v-chip>
              </div>
              <div v-if="a.state === 'leave'" class="detail-info">
                <v-icon x-small class="leave-icon mr-1">mdi-beach</v-icon> Leave
              </div>
 
              <div class="status-info">
                <template v-if="a.status === 'Approved'">
                  <v-icon x-small class="mr-1 approved-icon">mdi-check-circle</v-icon>
                  <span class="status-label">Approved{{ a.approvedBy ? ` ${a.approvedBy}` : '' }}</span>
                </template>
                <template v-else-if="a.status === 'Ready' && a.submittedBy">
                  <v-icon x-small class="mr-1 status-icon">mdi-arrow-up</v-icon>
                  <span class="status-label">Submitted: {{ a.submittedBy }}</span>
                </template>
                <template v-else-if="a.status === 'Pending' && a.modifiedBy">
                  <v-icon x-small class="mr-1 modified-icon">mdi-pencil</v-icon>
                  <span class="status-label">Modified: {{ a.modifiedBy }}</span>
                </template>
              </div>
            </div>
          </td>

          <!-- Leave Days Detail -->
          <td>
            <template v-if="item.leaveRecords.some(a => a.status === 'Approved')">
              <div class="detail-subheader">Approved Leaves</div>
              <div
                v-for="(a, idx) of item.leaveRecords.filter(a => a.status === 'Approved')"
                :key="'leave-approved-'+idx"
                class="detail-row"
              >
                <div class="detail-date">
                  <v-icon
                    x-small
                    class="mr-1 leave-icon"
                  >
                    mdi-beach
                  </v-icon>
                  <strong>{{ a.date | moment('ddd, D-MMM') }}</strong>
                </div>
                <div v-if="a.subState" class="detail-info">
                  <v-chip x-small outlined class="shift-chip">{{ a.subState }}</v-chip>
                </div>
                <!-- Submitted/Modified by for leave records -->
                <div class="status-info">
                  <template v-if="a.status === 'Approved'">
                    <v-icon x-small class="mr-1 approved-icon">mdi-check-circle</v-icon>
                    <span class="status-label">Approved{{ a.approvedBy ? ` ${a.approvedBy}` : '' }}</span>
                  </template>
                  <template v-else-if="a.status === 'Ready' && a.submittedBy">
                    <v-icon x-small class="mr-1 status-icon">mdi-arrow-up</v-icon>
                    <span class="status-label">Submitted: {{ a.submittedBy }}</span>
                  </template>
                  <template v-else-if="a.status === 'Pending' && a.modifiedBy">
                    <v-icon x-small class="mr-1 modified-icon">mdi-pencil</v-icon>
                    <span class="status-label">Modified: {{ a.modifiedBy }}</span>
                  </template>
                </div>
              </div>
            </template>
            <template v-if="item.leaveRecords.some(a => a.status !== 'Approved')">
              <div class="detail-subheader"><v-icon x-small class="modified-icon">mdi-pencil</v-icon> Unapproved Leaves</div>
              <div
                v-for="(a, idx) of item.leaveRecords.filter(a => a.status !== 'Approved')"
                :key="'leave-unapproved-'+idx"
                class="detail-row"
              >
                <div class="detail-date">
                  <v-icon
                    x-small
                    class="mr-1 leave-icon"
                  >
                    mdi-beach
                  </v-icon>
                  <strong>{{ a.date | moment('ddd, D-MMM') }}</strong>
                </div>
                <div v-if="a.subState" class="detail-info">
                  <v-chip x-small outlined class="shift-chip">{{ a.subState }}</v-chip>
                </div>
                <!-- Submitted/Modified by for leave records -->
                <div class="status-info">
                  <template v-if="a.status === 'Approved'">
                    <v-icon x-small class="mr-1 approved-icon">mdi-check-circle</v-icon>
                    <span class="status-label">Approved{{ a.approvedBy ? ` ${a.approvedBy}` : '' }}</span>
                  </template>
                  <template v-else-if="a.status === 'Ready' && a.submittedBy">
                    <v-icon x-small class="mr-1 status-icon">mdi-arrow-up</v-icon>
                    <span class="status-label">Submitted: {{ a.submittedBy }}</span>
                  </template>
                  <template v-else-if="a.status === 'Pending' && a.modifiedBy">
                    <v-icon x-small class="mr-1 modified-icon">mdi-pencil</v-icon>
                    <span class="status-label">Modified: {{ a.modifiedBy }}</span>
                  </template>
                </div>
              </div>
            </template>
          </td>

          <!-- Missed Punch Detail -->
          <td>
            <div
              v-for="(a, idx) of item.missedPunchRecords"
              :key="'missed-'+idx"
              class="detail-row"
            >
              <div class="detail-date">
                <v-icon
                  x-small
                  class="mr-1 missed-icon"
                >
                  mdi-alarm-off
                </v-icon>
                <strong>{{ a.date | moment('ddd, D-MMM') }}</strong>
              </div>
              <div class="detail-info detail-info-vertical">
                 <!-- Clock In Missed - Current -->
                 <template v-if="!a.clockIn && a.shift && a.shift.clockIn">
                   <div class="missed-entry">
                     <span class="missed-type">Clock In Missed</span>
                     <v-chip
                       x-small
                       class="deduction-chip"
                     >
                       +{{ formatCompactHours(a.missedHrsDetail && a.missedHrsDetail.clockIn || 0) }}
                     </v-chip>
                   </div>
                 </template>
                 <!-- Clock In Missed - Original (only if different from current) -->
                 <template v-if="!a.fromMachine && a.originalTime && a.originalTime.missedHrsDetail && a.originalTime.missedHrsDetail.clockIn > 0 && a.originalTime.missedHrsDetail.clockIn !== (a.missedHrsDetail && a.missedHrsDetail.clockIn || 0) && a.status !== 'Approved'">
                   <div class="missed-entry">
                     <span class="missed-type">Clock In Missed (Original)</span>
                     <v-chip
                       x-small
                       class="original-chip"
                     >
                       +{{ formatCompactHours(a.originalTime.missedHrsDetail.clockIn) }}
                     </v-chip>
                   </div>
                 </template>
                 <!-- Clock Out Missed - Current -->
                 <template v-if="!a.clockOut && a.shift && a.shift.clockOut">
                   <div class="missed-entry">
                     <span class="missed-type">Clock Out Missed</span>
                     <v-chip
                       x-small
                       class="deduction-chip"
                     >
                       +{{ formatCompactHours(a.missedHrsDetail && a.missedHrsDetail.clockOut || 0) }}
                     </v-chip>
                   </div>
                 </template>
                 <!-- Clock Out Missed - Original (only if different from current) -->
                 <template v-if="!a.fromMachine && a.originalTime && a.originalTime.missedHrsDetail && a.originalTime.missedHrsDetail.clockOut > 0 && a.originalTime.missedHrsDetail.clockOut !== (a.missedHrsDetail && a.missedHrsDetail.clockOut || 0) && a.status !== 'Approved'">
                   <div class="missed-entry">
                     <span class="missed-type">Clock Out Missed (Original)</span>
                     <v-chip
                       x-small
                       class="original-chip"
                     >
                       +{{ formatCompactHours(a.originalTime.missedHrsDetail.clockOut) }}
                     </v-chip>
                   </div>
                 </template>
                <!-- Submitted/Modified by -->
                <div class="status-info">
                  <template v-if="a.status === 'Approved'">
                    <v-icon x-small class="mr-1 approved-icon">mdi-check-circle</v-icon>
                    <span class="status-label">Approved{{ a.approvedBy ? ` ${a.approvedBy}` : '' }}</span>
                  </template>
                  <template v-else-if="a.status === 'Ready' && a.submittedBy">
                    <v-icon x-small class="mr-1 status-icon">mdi-arrow-up</v-icon>
                    <span class="status-label">Submitted: {{ a.submittedBy }}</span>
                  </template>
                  <template v-else-if="a.status === 'Pending' && a.modifiedBy">
                    <v-icon x-small class="mr-1 status-icon">mdi-pencil</v-icon>
                    <span class="status-label">Modified: {{ a.modifiedBy }}</span>
                  </template>
                </div>
              </div>
            </div>
          </td>

          <!-- Late Hours Detail -->
          <td>
            <div
              v-for="(a, idx) of item.lateHrsRecords"
              :key="'late-'+idx"
              class="detail-row"
            >
              <div class="detail-date">
                <v-icon
                  x-small
                  class="mr-1 late-icon"
                >
                  mdi-clock-alert
                </v-icon>
                <strong>{{ a.date | moment('ddd, D-MMM') }}</strong>
              </div>
              <div class="detail-info detail-info-vertical">
                 <!-- Clock In Late -->
                 <template v-if="a.clockIn && a.missedHrsDetail && a.missedHrsDetail.clockIn && (a.missedHrsDetail.clockIn - (a.missedHrsDetail.penalty && a.missedHrsDetail.penalty.clockIn || 0)) > 0">
                   <div class="late-entry">
                     <div class="late-header">
                       <span class="late-label">Late Arrival</span>
                       <v-chip
                         x-small
                         class="late-chip"
                       >
                         +{{ formatCompactHours(a.missedHrsDetail.clockIn - (a.missedHrsDetail.penalty && a.missedHrsDetail.penalty.clockIn || 0)) }}
                       </v-chip>
                       <v-chip
                         v-if="!a.fromMachine && a.originalTime && a.originalTime.missedHrsDetail && a.originalTime.missedHrsDetail.clockIn > 0 && a.originalTime.missedHrsDetail.clockIn !== a.missedHrsDetail.clockIn && a.status !== 'Approved'"
                         x-small
                         class="original-chip"
                       >
                         +{{ formatCompactHours(a.originalTime.missedHrsDetail.clockIn - (a.originalTime.missedHrsDetail.penalty && a.originalTime.missedHrsDetail.penalty.clockIn || 0)) }}
                       </v-chip>
                     </div>
                     <div class="time-details">
                       <span class="time-expected">Exp: {{ a.shift.clockIn | moment('HH:mm') }}</span>
                       <span class="time-actual">Act: {{ a.clockIn | moment('HH:mm') }}</span>
                     </div>
                   </div>
                 </template>
                 <!-- Clock Out Early -->
                 <template v-if="a.clockOut && a.missedHrsDetail && a.missedHrsDetail.clockOut && (a.missedHrsDetail.clockOut - (a.missedHrsDetail.penalty && a.missedHrsDetail.penalty.clockOut || 0)) > 0">
                   <div class="late-entry">
                     <div class="late-header">
                       <span class="late-label">Early Departure</span>
                       <v-chip
                         x-small
                         class="late-chip"
                       >
                         -{{ formatCompactHours(a.missedHrsDetail.clockOut - (a.missedHrsDetail.penalty && a.missedHrsDetail.penalty.clockOut || 0)) }}
                       </v-chip>
                       <v-chip
                         v-if="!a.fromMachine && a.originalTime && a.originalTime.missedHrsDetail && a.originalTime.missedHrsDetail.clockOut > 0 && a.originalTime.missedHrsDetail.clockOut !== a.missedHrsDetail.clockOut && a.status !== 'Approved'"
                         x-small
                         class="original-chip"
                       >
                         -{{ formatCompactHours(a.originalTime.missedHrsDetail.clockOut - (a.originalTime.missedHrsDetail.penalty && a.originalTime.missedHrsDetail.penalty.clockOut || 0)) }}
                       </v-chip>
                     </div>
                     <div class="time-details">
                       <span class="time-expected">Exp: {{ a.shift.clockOut | moment('HH:mm') }}</span>
                       <span class="time-actual">Act: {{ a.clockOut | moment('HH:mm') }}</span>
                     </div>
                   </div>
                 </template>
                <!-- Submitted/Modified by -->
                <div  class="status-info">
                  <template v-if="a.status === 'Approved'">
                    <v-icon x-small class="mr-1 approved-icon">mdi-check-circle</v-icon>
                    <span class="status-label">Approved{{ a.approvedBy ? ` ${a.approvedBy}` : '' }}</span>
                  </template>
                  <template v-else-if="a.status === 'Ready' && a.submittedBy">
                    <v-icon x-small class="mr-1 status-icon">mdi-arrow-up</v-icon>
                    <span class="status-label">Submitted: {{ a.submittedBy }}</span>
                  </template>
                  <template v-else-if="a.status === 'Pending' && a.modifiedBy">
                    <v-icon x-small class="mr-1 status-icon">mdi-pencil</v-icon>
                    <span class="status-label">Modified: {{ a.modifiedBy }}</span>
                  </template>
                </div>
              </div>
            </div>
          </td>

          <!-- Penalty Hours Detail -->
          <td>
            <div
              v-for="(a, idx) of item.penaltyHoursRecords"
              :key="'penalty-'+idx"
              class="detail-row"
            >
              <div class="detail-date">
                <v-icon
                  x-small
                  class="mr-1 penalty-icon"
                >
                  mdi-alert-circle
                </v-icon>
                <strong>{{ a.date | moment('ddd, D-MMM') }}</strong>
              </div>
               <div class="detail-info">
                 <template v-if="a.clockIn && a.missedHrsDetail && a.missedHrsDetail.penalty && a.missedHrsDetail.penalty.clockIn">
                   <div class="penalty-entry">
                     <span class="penalty-label">Penalty</span>
                     <v-chip
                       x-small
                       class="penalty-chip"
                     >
                       {{ formatCompactHours(a.missedHrsDetail.penalty.clockIn) }}
                     </v-chip>
                     <v-chip
                       v-if="!a.fromMachine && a.originalTime && a.originalTime.missedHrsDetail && a.originalTime.missedHrsDetail.penalty && a.originalTime.missedHrsDetail.penalty.clockIn > 0 && a.originalTime.missedHrsDetail.penalty.clockIn !== a.missedHrsDetail.penalty.clockIn && a.status !== 'Approved'"
                       x-small
                       class="original-chip"
                     >
                       {{ formatCompactHours(a.originalTime.missedHrsDetail.penalty.clockIn) }}
                     </v-chip>
                   </div>
                 </template>
                <!-- Submitted/Modified by -->
                <div  class="status-info">
                  <template v-if="a.status === 'Approved'">
                    <v-icon x-small class="mr-1 approved-icon">mdi-check-circle</v-icon>
                    <span class="status-label">Approved{{ a.approvedBy ? ` ${a.approvedBy}` : '' }}</span>
                  </template>
                  <template v-else-if="a.status === 'Ready' && a.submittedBy">
                    <v-icon x-small class="mr-1 status-icon">mdi-arrow-up</v-icon>
                    <span class="status-label">Submitted: {{ a.submittedBy }}</span>
                  </template>
                  <template v-else-if="a.status === 'Pending' && a.modifiedBy">
                    <v-icon x-small class="mr-1 status-icon">mdi-pencil</v-icon>
                    <span class="status-label">Modified: {{ a.modifiedBy }}</span>
                  </template>
                </div>
              </div>
            </div>
          </td>

          <td />
        </template>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapGetters, mapState, mapMutations } from 'vuex'
  import moment from 'moment'
  import { fetchDetailReport } from '@/helpers/tikApi'
  import MemberSelector from '@/views/dashboard/components/MemberSelector'
  import ViewXSelector from '@/views/dashboard/components/ViewXSelector'
  import { exportDetailTimeToExcel } from '@/helpers/exportDetailTime'

  export default {
    name: 'DetailTime',
    components: { MemberSelector, ViewXSelector },
    data: () => ({
      expanded: null,
      viewMode: 'detail',
      groupByGroup: true,
      reportData: [],
      loading: false,
      headers: [
        { text: '#', value: 'sn', width: '40px', align: 'center' },
        { text: 'Name', value: 'name', width: '140px' },
        { text: 'AbsentDays', value: 'absentDays', width: '100px' },
        { text: 'Appr Mods', value: 'apprMods', width: '80px' },
        { text: 'LeaveDays', value: 'leaveDays', width: '100px' },
        { text: 'Missed Punch', value: 'missedPunch', width: '120px' },
        { text: 'Late Hours', value: 'lateHrs', width: '220px' },
        { text: 'Penalty Hours', value: 'penaltyHours', width: '100px' },
        { text: 'Pay hrs', value: 'fullPayHours', width: '100px' },
      ],
      exporting: false,
      downloading: false,
      filename: '',
      selectedMember: [],
      selectedGroups: [],
      selectedJobLevel: [],
      autoWidth: true,
      bookType: 'xlsx',
    }),
    computed: {
      ...mapState('records', ['view', 'currentDate', 'startDate', 'endDate', 'selectedMembersId']),
      ...mapGetters([
        'team', 'company', 'teamFull', 'groups', 'user', 'roles', 'workCloseDays', 'userGroups', 'groupsFull', 'groupLabel', 'parentGroupLabel', 'groupLabelPlural', 'parentGroupLabelPlural',
      ]),
      groupMap () {
        return (this.groupsFull || []).reduce((acc, g) => {
          acc[g.code] = g.name
          return acc
        }, {})
      },
      adjustedSummery () {
        return this.reportData || []
      },
      filteredData () {
        return this.adjustedSummery.filter(m =>
          (!this.selectedMember.length || this.selectedMember.includes(m.memberId)) &&
          (!this.selectedGroups.length || this.selectedGroups.includes(m.group)) &&
          (!this.selectedJobLevel.length || (m.jobLevel && this.selectedJobLevel.includes(m.jobLevel)))
        )
      },
      members () {
        if (!this.reportData) return []
        return this.reportData.map(r => ({
          id: r.memberId,
          fullName: r.name,
          jobTitle: r.jobTitle,
        }))
      },
    },
    watch: {
      startDate () {
        this.loadReport()
      },
      endDate () {
        this.loadReport()
      },
      team () {
        this.loadReport()
      },
      selectedGroups () {
        this.loadReport()
      },
      groups (newGroups) {
        console.log('groups changed', newGroups)
        if (newGroups && newGroups.length > 0 && this.selectedGroups.length === 0) {
          this.selectedGroups = [newGroups[0]]
          console.log(this.selectedGroups)
        }
      },
    },
    created () {
      this.loadReport()
    },
    mounted () {
      this.$root.$on('export-detailtime-excel', this.exportToExcel)
    },
    beforeDestroy () {
      this.$root.$off('export-detailtime-excel', this.exportToExcel)
    },
    methods: {
      async loadReport () {
        if (!this.startDate || !this.endDate || !this.team) return
        this.loading = true
        try {
          const groups = this.selectedGroups.length ? this.selectedGroups.join(',') : null
          this.reportData = await fetchDetailReport(
            this.startDate,
            this.endDate,
            this.team,
            false,
            groups
          )
        } catch (e) {
          console.error('Failed to load detail report', e)
        } finally {
          this.loading = false
        }
      },
      expandAll () {
        this.expanded = this.adjustedSummery
      },
      collapseAll () {
        this.expanded = []
      },

      getApprovedModCount (item) {
        return (item.noRecordAbsentRecords || []).filter(r => r.status === 'Approved').length
      },
      /**
       * Format dates for simple view - shows only day (DD) separated by commas
       * e.g., "05, 12, 18, 25"
       */
      formatCompactDates (records) {
        if (!records || !records.length) return '-'
        return records.map(r => moment(r.date).format('DD')).join(', ')
      },

      /**
       * Format hours for simple view
       * - Hours >= 1: show as "Xh" (e.g., "1.5h")
       * - Hours < 1: show as "Xm" (e.g., "30m")
       */
      formatCompactHours (hours) {
        if (!hours || hours <= 0) return null
        if (hours < 1) {
          return Math.round(hours * 60) + 'm'
        }
        return hours.toFixed(2) + 'h'
      },

      /**
       * Format late hours records for simple view
       * Shows: "in 30m, out 1.25h" format
       */
      formatCompactLateHours (records) {
        if (!records || !records.length) return '-'

        const parts = []
        records.forEach(r => {
          const date = moment(r.date).format('DD')
          const lateIn = r.clockIn && r.missedHrs && r.missedHrs.clockIn
            ? r.missedHrs.clockIn - (r.missedHrs.penalty && r.missedHrs.penalty.clockIn || 0)
            : 0
          const lateOut = r.clockOut && r.missedHrs && r.missedHrs.clockOut
            ? r.missedHrs.clockOut - (r.missedHrs.penalty && r.missedHrs.penalty.clockOut || 0)
            : 0
          const inPart = lateIn > 0 ? `in ${this.formatCompactHours(lateIn)}` : null
          const outPart = lateOut > 0 ? `out ${this.formatCompactHours(lateOut)}` : null

          const timeParts = [inPart, outPart].filter(Boolean)
          if (timeParts.length) {
            parts.push(`${date}(${timeParts.join(', ')})`)
          }
        })

        return parts.length ? parts.join(', ') : '-'
      },

      /**
       * Format penalty hours records for simple view
       */
      formatCompactPenaltyHours (records) {
        if (!records || !records.length) return '-'

        const parts = []
        records.forEach(r => {
          const date = moment(r.date).format('DD')
          if (r.clockIn && r.missedHrs && r.missedHrs.penalty && r.missedHrs.penalty.clockIn) {
            parts.push(`${date}(in ${this.formatCompactHours(r.missedHrs.penalty.clockIn)})`)
          }
        })

        return parts.length ? parts.join(', ') : '-'
      },

      /**
       * Format single late hours record for simple view
       */
      formatSingleLateHours (record) {
        const lateIn = record.clockIn && record.missedHrs && record.missedHrs.clockIn
          ? record.missedHrs.clockIn - (record.missedHrs.penalty && record.missedHrs.penalty.clockIn || 0)
          : 0
        const lateOut = record.clockOut && record.missedHrs && record.missedHrs.clockOut
          ? record.missedHrs.clockOut - (record.missedHrs.penalty && record.missedHrs.penalty.clockOut || 0)
          : 0
        const inPart = lateIn > 0 ? `in ${this.formatCompactHours(lateIn)}` : null
        const outPart = lateOut > 0 ? `out ${this.formatCompactHours(lateOut)}` : null
        const timeParts = [inPart, outPart].filter(Boolean)
        return timeParts.length ? `(${timeParts.join(', ')})` : ''
      },

      /**
       * Format single penalty hours record for simple view
       */
      formatSinglePenaltyHours (record) {
        if (record.clockIn && record.missedHrs && record.missedHrs.penalty && record.missedHrs.penalty.clockIn) {
          return `(in ${this.formatCompactHours(record.missedHrs.penalty.clockIn)})`
        }
        return ''
      },

      /**
       * Format missed punch records for simple view
       * Shows: "08(In), 12(Out)" format
       */
      formatCompactMissedPunch (records) {
        if (!records || !records.length) return '-'

        return records.map(r => {
          const date = moment(r.date).format('DD')
          let type = ''
          if (!r.clockIn && r.shift && r.shift.clockIn) {
            type = 'In'
          } else if (!r.clockOut && r.shift && r.shift.clockOut) {
            type = 'Out'
          }
          return type ? `${date}(${type})` : date
        }).join(', ')
      },

      /**
       * Format a single missed punch record with date and type
       * Checks missedHrsDetail.missedPunch for punch type
       */
      formatDateWithPunchType (record) {
        const date = moment(record.date).format('DD')
        let type = ''

        // Check missedPunch in missedHrsDetail
        if (record.missedHrsDetail && record.missedHrsDetail.missedPunch) {
          if (record.missedHrsDetail.missedPunch.clockIn > 0) {
            type = 'In'
          } else if (record.missedHrsDetail.missedPunch.clockOut > 0) {
            type = 'Out'
          }
        }

        // For corrected records (not approved), check original time's missedPunch
        if (!type && record.status !== 'Approved' && record.originalTime && record.originalTime.missedHrsDetail && record.originalTime.missedHrsDetail.missedPunch) {
          if (record.originalTime.missedHrsDetail.missedPunch.clockIn > 0) {
            type = 'In'
          } else if (record.originalTime.missedHrsDetail.missedPunch.clockOut > 0) {
            type = 'Out'
          }
        }

        return type ? `${date}(${type})` : date
      },

      /**
       * Get missed punch records that have been modified/submitted by a user
       */
      getModifiedMissedPunchRecords (records) {
        if (!records || !records.length) return []
        return records.filter(r => !r.fromMachine && r.status !== 'Approved' && (r.submittedBy || r.modifiedBy))
      },

      /**
       * Get late hours records that have been modified/submitted by a user
       */
      getModifiedLateRecords (records) {
        if (!records || !records.length) return []
        return records.filter(r => !r.fromMachine && r.status !== 'Approved' && (r.submittedBy || r.modifiedBy))
      },

      /**
       * Get penalty records that have been modified/submitted by a user
       */
      getModifiedPenaltyRecords (records) {
        if (!records || !records.length) return []
        return records.filter(r => !r.fromMachine && r.status !== 'Approved' && (r.submittedBy || r.modifiedBy))
      },
      exportToExcel () {
        this.exporting = true
        const sDate = moment(this.startDate).format('DD/MM/YYYY')
        const eDate = moment(this.endDate).format('DD/MM/YYYY')
        const companyHeader = `${this.company || ''} ${this.teamFull?.name || ''}`.trim()

        exportDetailTimeToExcel({
          items: this.filteredData,
          groupBy: this.groupByGroup,
          companyHeader,
          title: 'Detail Time Report',
          dateRangeText: `Period: ${sDate} - ${eDate}`,
          groupLabel: this.groupLabel,
          groupMap: this.groupMap,
          formatters: {
            formatCompactDates: this.formatCompactDates.bind(this),
            formatCompactMissedPunch: this.formatCompactMissedPunch.bind(this),
            formatSingleLateHours: this.formatSingleLateHours.bind(this),
            formatSinglePenaltyHours: this.formatSinglePenaltyHours.bind(this),
          },
          filename: `Detail Time Report - ${sDate.replace(/\//g, '-')}`,
        })

        this.exporting = false
      },
    },
  }
</script>

<style scoped>
/* Simple view styles for compact display - uses Vuetify text classes for dark mode support */
.simple-dates {
  line-height: 1.4;
}

.simple-missed-entry {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 2px;
}

.simple-modified {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  color: #1976d2;
  font-style: italic;
}

.simple-late-hours {
  line-height: 1.4;
}

/* Detail view styles */
.detail-row {
  padding: 8px 0;
  border-bottom: 1px solid rgba(128, 128, 128, 0.2);
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-date {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.detail-subheader {
  font-weight: bold;
  font-size: 12px;
  margin: 8px 0 4px 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

.detail-info {
  padding-left: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.detail-info-vertical {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

/* Icon colors that work in both light and dark mode */
.absent-icon {
  color: #ef5350 !important;
}

.leave-icon {
  color: #42a5f5 !important;
}

.time-icon {
  color: #42a5f5 !important;
}

.missed-icon {
  color: #ffa726 !important;
}

.late-icon {
  color: #ffa726 !important;
}

.penalty-icon {
  color: #e53935 !important;
}

/* Chip styles for dark mode compatibility */
.shift-chip {
  font-size: 10px;
  height: 18px;
}

.deduction-chip {
  font-size: 10px;
  height: 20px;
  background-color: rgba(239, 83, 80, 0.15) !important;
  color: #ef5350 !important;
}

.late-chip {
  font-size: 10px;
  height: 20px;
  background-color: rgba(255, 167, 38, 0.15) !important;
  color: #ffa726 !important;
}

.penalty-chip {
  font-size: 10px;
  height: 20px;
  background-color: rgba(229, 57, 53, 0.15) !important;
  color: #e53935 !important;
}

.original-chip {
  font-size: 10px;
  height: 18px;
  background-color: rgba(156, 39, 176, 0.15) !important;
  color: #9c27b0 !important;
  margin-left: 4px;
}

.missed-type,
.late-label,
.penalty-label,
.status-label {
  font-weight: 500;
  font-size: 11px;
}

.status-info {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px dashed rgba(128, 128, 128, 0.2);
  display: flex;
  align-items: center;
}

.status-icon {
  color: #1976d2 !important;
}

.approved-icon {
  color: #4caf50 !important;
}

.modified-icon {
  color: #ff9800 !important;
}

.status-label {
  color: #1976d2;
  font-style: italic;
}

.late-entry,
.penalty-entry,
.missed-entry {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 6px;
}

.late-entry:last-child,
.penalty-entry:last-child,
.missed-entry:last-child {
  margin-bottom: 0;
}

.late-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.time-details {
  display: flex;
  gap: 12px;
  font-size: 10px;
  padding-left: 0;
}

.time-expected {
  opacity: 0.7;
}

.time-actual {
  font-weight: 500;
}

/* Print-friendly styles */
@media print {
  /* Hide the toggle in print */
  .no-print {
    display: none !important;
  }

  /* Make table more compact for printing */
  ::v-deep .v-data-table__wrapper {
    font-size: 9px;
  }

  ::v-deep .v-data-table th {
    font-size: 9px;
    padding: 4px 6px !important;
    height: auto !important;
  }

  ::v-deep .v-data-table td {
    font-size: 9px;
    padding: 3px 6px !important;
    height: auto !important;
  }

  /* Compact simple view in print */
  .simple-dates,
  .simple-late-hours {
    font-size: 10px;
    line-height: 1.2;
    color: #000 !important;
  }

  /* Detail view print styles */
  .detail-row {
    padding: 4px 0;
  }

  .detail-info {
    font-size: 9px;
  }

  .missed-type,
  .late-label,
  .penalty-label {
    font-size: 9px;
  }

  .deduction-chip,
  .late-chip,
  .penalty-chip,
  .original-chip {
    font-size: 8px;
    height: 16px;
  }

  /* Reduce row height */
  ::v-deep .v-data-table__wrapper tbody tr {
    height: auto !important;
  }

  /* Ensure expanded rows don't take too much space */
  ::v-deep .v-data-table__expanded__row td {
    padding: 2px 6px !important;
  }
}
</style>
